import { events } from 'aws-amplify/data';

import { type ChannelNamespace, fleetChannel } from './channels';

type Handlers = {
    next: (event: unknown) => void;
    error: (error: unknown) => void;
};

export const subscribeToFleetChannel = async (namespace: ChannelNamespace, fleetId: string, handlers: Handlers) => {
    const channel = fleetChannel(namespace, fleetId);
    const eventsChannel = await events.connect(channel);

    const subscription = eventsChannel.subscribe({
        next: received => {
            console.info(`[events] ${channel}`, received.event);
            handlers.next(received.event);
        },
        error: error => handlers.error(error),
    });

    return {
        unsubscribe: () => {
            subscription.unsubscribe();
            eventsChannel.close();
        },
    };
};
